import { useContext } from 'react';
import BypassContext, { IAppDataContext } from '../context/ApplicationDataContext';

export const useApplicationDataContext = (): IAppDataContext => {
    return useContext(BypassContext);
};
